export default {"src":"/_next/static/media/favicon.2cea167b.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};